import { Injectable, Injector } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { ListHelperService } from 'core/services';
import { MarsGroup, MarsGroupList } from '../models/MarsGroup';
import { MarsHttpDataService } from './mars-http-data.service';

@Injectable()
export class MarsGroupService extends MarsHttpDataService {
  constructor(protected injector: Injector, private listHelperService: ListHelperService) {
    super(injector, '/groups');
  }

  /**
   * Fetch of the mars group list
   * @param clientId
   * @param options
   * @param dataSource
   */
  public fetch$(
    clientId: string,
    options?: {
      page: number;
      limit: number;
      sort: string;
      search: string;
      filters: any;
      aggregates: string;
      populate: string;
    },
    dataSource?: TableDatasource
  ): Observable<MarsGroupList> {
    const url = `${this.baseUrl}`;
    const { status, ...$filterValues } = options.filters;
    const $filter = this.listHelperService.buildFilterString($filterValues, dataSource);
    const paginationOptions = {
      page: options.page,
      limit: options.limit,
      sort: options.sort,
      search: options.search,
      aggregates: options.aggregates,
      populate: options.populate,
      clientId,
      $status: status,
      $filter
    };

    return this.fetchRequest(url, paginationOptions);
  }

  public getMarsGroup$(matchId: string): Observable<MarsGroup> {
    return super.getItem(matchId);
  }

  public getGroupActivity(groupId: string, options: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/${groupId}/activity`, this.getRequestOptions(options)));
  }

  public getGroupSurveys(groupId: string, options: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/${groupId}/surveys`, this.getRequestOptions(options)));
  }

  public getGroupSurveysSummary(groupId: string, options: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/${groupId}/surveys-summary`, this.getRequestOptions(options)));
  }
}
